const ReferredTransactionType = {
  REFERRAL: 1,
  REWARD: 2,
  ADJUSTMENT: 3,
};

const ReferredTransactionTypeDetails = {
  [ReferredTransactionType.REFERRAL]: {
    displayName: 'Referral',
  },
  [ReferredTransactionType.REWARD]: {
    displayName: 'Reward',
  },
  [ReferredTransactionType.ADJUSTMENT]: {
    displayName: 'Adjustment',
  },
};

export { ReferredTransactionType, ReferredTransactionTypeDetails };
